"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LotteryContractDeployButton = exports.LOTTERY_CONTRACT_DEPLOY_DIALOG_KEY = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const icons_material_1 = require("@mui/icons-material");
const react_hooks_eth_1 = require("@dzambalaorg/react-hooks-eth");
const provider_user_1 = require("@dzambalaorg/provider-user");
const styled_1 = require("@framework/styled");
const deployLottery_json_1 = __importDefault(require("@framework/abis/json/LotteryFactoryFacet/deployLottery.json"));
const react_hooks_1 = require("@dzambalaorg/react-hooks");
const dialog_1 = require("./dialog");
exports.LOTTERY_CONTRACT_DEPLOY_DIALOG_KEY = "lotteryContractDeploy";
const LotteryContractDeployButton = (props) => {
    const { className, disabled, variant = styled_1.ListActionVariant.button } = props;
    const { profile } = (0, provider_user_1.useUser)();
    const { writeContractAsync } = (0, react_hooks_eth_1.useWriteContractWithSimulation)();
    const { openFormDialog, formDialogUniqueKey, mode } = (0, react_hooks_1.useDialogForm)();
    const handleDeploy = () => {
        openFormDialog(exports.LOTTERY_CONTRACT_DEPLOY_DIALOG_KEY, void 0, "button");
    };
    const { handleDeployConfirm } = (0, react_hooks_eth_1.useDeploy)(async (values, sign, systemContract) => {
        const nonce = sign.nonce;
        return writeContractAsync({
            address: systemContract.address,
            abi: deployLottery_json_1.default,
            functionName: "deployLottery",
            args: [
                {
                    nonce,
                    bytecode: sign.bytecode,
                    externalId: BigInt(profile.id),
                },
                {
                    config: {
                        timeLagBeforeRelease: BigInt(values.config.timeLagBeforeRelease),
                        commission: BigInt(values.config.commission),
                    },
                },
                sign.signature,
            ],
        });
    });
    const onDeployConfirm = ({ data, form }) => {
        return handleDeployConfirm({
            url: "/contract-manager/lottery",
            method: "POST",
            data: { config: data },
        }, form);
    };
    return ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleDeploy, icon: icons_material_1.Add, message: "form.buttons.deploy", className: className, dataTestId: "LotteryDeployButton", disabled: disabled, variant: variant }), (0, jsx_runtime_1.jsx)(dialog_1.LotteryContractDeployDialog, { onExternalConfirm: onDeployConfirm, open: formDialogUniqueKey === `${exports.LOTTERY_CONTRACT_DEPLOY_DIALOG_KEY}.${mode}`, initialValues: {
                    timeLagBeforeRelease: 60 * 60 * 24 * 30, // 30 days in seconds
                    commission: 30, // 30%
                } })] }));
};
exports.LotteryContractDeployButton = LotteryContractDeployButton;
//# sourceMappingURL=index.js.map